import React from 'react';

import { useSelector } from 'react-redux';
import Dispensaries from '../dispensaries/Dispensaries';
import PickupDispensaries from '../dispensaryPickup/PickupDispensaries';

const DispensariesController = () => {
  
  const isPickup = useSelector(state => state.is_pickup);
  
  return isPickup
    ? <PickupDispensaries />
    : <Dispensaries />
}

export default DispensariesController;